const tr = {
  monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
  monthNamesShort: ["Oca", "Sub", "Mar", "Nis", "May", "Haz", "Tem", "Agu", "Eyl", "Eki", "Kas", "Ara"],

  dateFormat: "DD.MM.YYYY",
  dateFormatEdit: "YYYY-MM-DD",
  dateFormatWithHours: "DD.MM.YYYY HH:mm:ss",

  hourToDateFormat: "YYYY-MM-DD[T]HH:mm:ss",
  dateToHourFormat: "HH:mm",

  dataTableLoadingText: "Yükleniyor",
  dataTableNoDataText: "Veri Bulunamadı",

  dateTimeLocalFormat: "YYYY-MM-DDTHH:mm",

  dateMessageFormat: "lll",

  activePassiveList: [
    { label: "Aktif", value: true, label1: "Evet", value1: 1 },
    { label: "Pasif", value: false, label1: "Hayır", value1: 0 },
  ],

  timezoneList: [
    { label: "-12:00", value: "-12:00", tooltip: "Baker Adası, Howland Adası" },
    { label: "-11:00", value: "-11:00", tooltip: "Amerikan Samoası, Niue" },
    { label: "-10:00", value: "-10:00", tooltip: "Hawaii, Aleut Adalarının Batı Bölgesi" },
    { label: "-09:00", value: "-09:00", tooltip: "Alaska" },
    { label: "-08:00", value: "-08:00", tooltip: "ABD/Kanada/Meksika (Pasifik Saati)" },
    { label: "-07:00", value: "-07:00", tooltip: "ABD/Kanada/Meksika (Sıradağlar Saati)" },
    { label: "-06:00", value: "-06:00", tooltip: "ABD/Kanada/Meksika (Merkezi Saat)" },
    { label: "-05:00", value: "-05:00", tooltip: "ABD/Kanada/Meksika (Doğu Avrupa Saati), Küba, Peru" },
    { label: "-04:30", value: "-04:30", tooltip: "Venezuela" },
    { label: "-04:00", value: "-04:00", tooltip: "Kanada (Atlantik Saati), Lesser Antillerin Büyük Kısmı, Brezilya (Amazon Saati), Şili" },
    { label: "-03:30", value: "-03:30", tooltip: "Kanada (Newfoundland)" },
    { label: "-03:00", value: "-03:00", tooltip: "Brezilya (Brezilya saati), Arjantin, Grönland" },
    { label: "-02:00", value: "-02:00", tooltip: "Brezilya (Fernando de Noronha)" },
    { label: "-01:00", value: "-01:00", tooltip: "Azurlar, Yeşil Burun Adaları" },
    { label: "+00:00", value: "+00:00", tooltip: "Birleşik Krallık, İrlanda, Portekiz, İzlanda, Fas (Batı Afrika), Gana" },
    { label: "+01:00", value: "+01:00", tooltip: "Orta Avrupa Saati (Fransa, Almanya), Batı Afrika Saati (Nijerya, Kongo)" },
    { label: "+02:00", value: "+02:00", tooltip: "Doğu Avrupa Saati (Finlandiya, Yunanistan), Orta Afrika Saati, Güney Afrika" },
    { label: "+03:00", value: "+03:00", tooltip: "İstanbul, Ukrayna, Beyaz Rusya, Suudi Arabistan, Doğu Afrika Saati" },
    { label: "+03:30", value: "+03:30", tooltip: "İran" },
    { label: "+04:00", value: "+04:00", tooltip: "Russia (Moskova), Azerbaycan, Gürcistan, Birleşik Arap Emirlikleri, Mauritius" },
    { label: "+04:30", value: "+04:30", tooltip: "Afganistan" },
    { label: "+05:00", value: "+05:00", tooltip: "Pakistan" },
    { label: "+05:30", value: "+05:30", tooltip: "Hindistan" },
    { label: "+05:45", value: "+05:45", tooltip: "Nepal" },
    { label: "+06:00", value: "+06:00", tooltip: "Russia (Yekaterinburg), Kazakistan, Bangladeş" },
    { label: "+06:30", value: "+06:30", tooltip: "Myanmar, Cocos Adaları" },
    { label: "+07:00", value: "+07:00", tooltip: "Russia (Omsk), Moğolistan, Tayland, Vietnam, Cakarta" },
    { label: "+08:00", value: "+08:00", tooltip: "Russia (Krasnoyarsk), Çin, Moğolistan, Malezya, Avustralya (Batı Avustralya)" },
    { label: "+08:45", value: "+08:45", tooltip: "Avustralya (Eucla)" },
    { label: "+09:00", value: "+09:00", tooltip: "Russia (Irkutsk), Güney Kore, Japan, Palau" },
    { label: "+09:30", value: "+09:30", tooltip: "Avustralya (Kuzey Bölgesi, Güney Avustralya)" },
    { label: "+10:00", value: "+10:00", tooltip: "Russia (Yakutsk), Guam, Avustralya Batı Standart Saati" },
    { label: "+10:30", value: "+10:30", tooltip: "Avustralya (Lord Howe Adası)" },
    { label: "+11:00", value: "+11:00", tooltip: "Russia (Vladivostok), Solomon Adaları, Yeni Kaledonya" },
    { label: "+12:00", value: "+12:00", tooltip: "Russia (Magadan), Yeni Zelanda, Fiji, Kiribati (Gilbert Adaları)" },
    { label: "+12:45", value: "+12:45", tooltip: "Yeni Zelanda (Chatham Adası)" },
  ],
};

const currentDate = new Date().toISOString().slice(0, 10);

module.exports = { tr, currentDate };
